import React, { useState } from "react";
import {
	Button,
	Input,
	InputGroupText,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	InputGroup,
	UncontrolledCollapse,
	Card,
	CardBody,
	Spinner,
} from "reactstrap";
import { Locale } from "../translations/locale";
import { locales } from "./locales";
import { ResourceDetails } from "./ResourceDetails";
import "./styles.css";
import { cqrs } from "../cqrs.js";
import { useReactOidc } from "@axa-fr/react-oidc-context";

function ReadinessIndicator({ ResourceStopJobs }) {
	if (
		ResourceStopJobs == null ||
		!ResourceStopJobs.some(({ stopAt }) => {
			return stopAt;
		})
	) {
		return "🟡";
	} else {
		var dNow = new Date();
		if (
			ResourceStopJobs.every(({ stopAt }) => {
				return dNow.getTime() < new Date(stopAt).getTime();
			})
		) {
			return "🟢";
		} else if (
			ResourceStopJobs.every(({ stopAt }) => {
				return dNow.getTime() >= new Date(stopAt).getTime();
			})
		) {
			return "🔴";
		} else {
			return "🟡";
		}
	}
}

export const ScheduleItem = (props) => {
	const { environment } = props;
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [spinnerEnabled, setSpinnerEnabled] = useState(false);
	const toggleDropDown = () => setDropdownOpen(!dropdownOpen);
	const { oidcUser } = useReactOidc();

	const [uptime, setUptime] = useState(60);

	const uptimes = {
		60: { id: "uptime-1h", default: "1 hour" },
		120: { id: "uptime-2h", default: "2 hours", value: 120 },
		240: { id: "uptime-4h", default: "4 hours", value: 240 },
		480: { id: "uptime-8h", default: "8 hours", value: 480 },
	};

	const onStartEnvironment = () => {
		cqrs(
			"/api/schedule/start-environment-manually",
			{ environmentId: environment.id, uptimeInMinutes: uptime },
			oidcUser.id_token
		);
	};

	return (
		<>
			<InputGroup className="col col-lg-6 scheduler">
				<InputGroupText
					addonType="append"
					id={"toggler" + environment.id}
					style={{ cursor: "pointer", userSelect: "none" }}
				>
					{ReadinessIndicator({
						ResourceStopJobs: environment.stopJobs,
					})}
				</InputGroupText>
				<Input
					placeholder={environment.description || environment.name}
					disabled
				/>
				<InputGroupText addonType="append">
					<ButtonDropdown
						addonType="append"
						isOpen={dropdownOpen}
						toggle={toggleDropDown}
					>
						<DropdownToggle
							split
							outline
							color="info"
							style={{ backgroundColor: "#ffffff" }}
						>
							<Locale id={uptimes[uptime].id} locales={locales}>
								{uptimes[uptime].default}
							</Locale>
						</DropdownToggle>
						<DropdownMenu>
							{Object.keys(uptimes).map((key) => (
								<DropdownItem
									key={key}
									onClick={() => setUptime(key)}
								>
									<Locale
										id={uptimes[key].id}
										locales={locales}
									>
										{uptimes[key].default}
									</Locale>
								</DropdownItem>
							))}
						</DropdownMenu>
						<Button
							color="info"
							onClick={() => {
								onStartEnvironment(environment.id);
								setSpinnerEnabled(true);
								setTimeout(
									() => setSpinnerEnabled(false),
									3000
								);
							}}
						>
							{!spinnerEnabled ? (
								<Locale
									id={"list-header-start"}
									locales={locales}
								>
									Start
								</Locale>
							) : (
								<Spinner size="sm"></Spinner>
							)}
						</Button>
					</ButtonDropdown>
				</InputGroupText>
				<UncontrolledCollapse
					toggler={"#toggler" + environment.id}
					style={{ width: "100%" }}
				>
					<Card>
						<CardBody>
							<ResourceDetails
								ResourceStopJobs={environment.stopJobs}
							/>
						</CardBody>
					</Card>
				</UncontrolledCollapse>
			</InputGroup>
		</>
	);
};
